// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__BQjmP","tab":"UserNav_tab__2v7U6"};